export const DEMO_CLUB_EMAIL = 'demo@snowsproam.com';
export const AFRIRUN_DEMO_SEED = 'afrirun-institute-demo-v1';
export const AFRIRUN_TOTAL_STEPS = 2846320;
export const AFRIRUN_WORKSPACE_LOGO_URL = 'https://media.snowsproam.com/Demo-Institute/AfriRun/afrirun-logo.jpg';
export const AFRIRUN_COMMUNITY_IMAGE_URL = 'https://media.snowsproam.com/Demo-Institute/AfriRun/afrirun-community.jpg';
export const JUST_US_DEMO_SEED = 'just-us-institute-demo-v1';
export const LEIXLIP_AMENITIES_DEMO_SEED = 'leixlip-amenities-demo-v1';
export const JUST_US_TOTAL_STEPS = 2276430;
export const JUST_US_WORKSPACE_LOGO_URL = 'https://media.snowsproam.com/Demo-Institute/Just-Us/just-us-avatar-v2.webp';
export const JUST_US_RUN_GROUP_URL = 'https://media.snowsproam.com/Demo-Institute/Just-Us/just-us-run-group-v2.webp';
export const JUST_US_BOOK_CLUB_URL = 'https://media.snowsproam.com/Demo-Institute/Just-Us/just-us-book-club-v2.webp';

export const DEMO_CLUB_INSTITUTE_NAMES = [
  'AfriRun Members',
  'AfriRun Run Crews',
  'AfriRun Move Together 75K',
  'AfriRun 7 Day Consistency Challenge',
  'Just Us Members',
  'Just Us Circles',
  'Glow and Go',
  'Belfast Front Runners Members',
  'Belfast Front Runners Run Groups',
  'Belfast Front Runners 50K Challenge',
];

export const isDemoClubAccount = (email = '') =>
  /^demo(?:[+._-][^@]+)?@snowsproam\.com$/i.test(String(email || '').trim());

export const isDemoClubLeaderboard = (email, type) =>
  String(email || '').trim().toLowerCase() === DEMO_CLUB_EMAIL
  && String(type || '').toLowerCase() === 'club';

export const isDemoClubInstituteRow = (row = {}) =>
  String(row?.brand_settings?.demo_seed || row?.demo_seed || '').toLowerCase() === LEIXLIP_AMENITIES_DEMO_SEED
  || DEMO_CLUB_INSTITUTE_NAMES.some(
    (name) => String(row?.name || '').toLowerCase() === name.toLowerCase(),
  );

export const isAfriRunDemoInstitute = (institute = {}, email = '') =>
  isDemoClubAccount(email)
  && String(institute?.brand_settings?.demo_seed || '').toLowerCase() === AFRIRUN_DEMO_SEED;

export const isJustUsDemoInstitute = (institute = {}, email = '') =>
  isDemoClubAccount(email)
  && String(institute?.brand_settings?.demo_seed || '').toLowerCase() === JUST_US_DEMO_SEED;

export const buildDemoClubLeaderboard = ({ realRows = [] } = {}) => {
  const byWorkspace = new Map();
  realRows.forEach((row) => {
    if (!row?.id || row.is_active === false || row.archived_at || row.has_teams || row.teams) return;
    const key = row.workspace_id || row.id;
    if (byWorkspace.has(key)) return;
    const imageUrl = row.workspace_logo_url || row.brand_logo_url || row.image_url || '';
    byWorkspace.set(key, {
      ...row,
      name: row.name,
      type: 'Club',
      institute_type: 'Club',
      region: row.state_province,
      image: imageUrl,
      image_url: imageUrl,
      totalSteps: Number(row.total_steps ?? row.totalSteps) || 0,
      accessLocked: false,
    });
  });
  return [...byWorkspace.values()]
    .sort((a, b) => b.totalSteps - a.totalSteps || a.name.localeCompare(b.name))
    .map((row, index) => ({ ...row, rank: index + 1 }));
};


export const buildAfriRunDemoCommunity = (institute = {}, email = '') => {
  if (!isAfriRunDemoInstitute(institute, email) || !institute?.id) return null;
  const workspaceLogoUrl = institute.workspace_logo_url
    || institute.brand_logo_url
    || institute.display_logo_url
    || AFRIRUN_WORKSPACE_LOGO_URL;
  const communityImageUrl = institute.image_url && institute.image_url !== workspaceLogoUrl
    ? institute.image_url
    : AFRIRUN_COMMUNITY_IMAGE_URL;
  return {
    id: 'demo-only-afrirun-community',
    name: 'afrirun',
    description: 'A welcoming space for AfriRun members to organise runs, share routes and celebrate every finish together.',
    image_url: workspaceLogoUrl,
    imageUrl: workspaceLogoUrl,
    description_image_url: communityImageUrl,
    gallery_images: [{ id: 'demo-only-afrirun-community-photo', image_url: communityImageUrl, position: 0 }],
    private: true,
    sport_id: 'Fitness',
    sport_label: 'Fitness',
    institute_id: institute.id,
    institute_team_id: null,
    institute_team_names: ['Social 5K', 'Tempo & 10K', 'Long Run Crew', 'Beginners & Returners', 'Parkrun & Coffee'],
    member_count: 42,
    demo_only: true,
  };
};

export const buildJustUsDemoCommunity = (institute = {}, email = '') => {
  if (!isJustUsDemoInstitute(institute, email) || !institute?.id) return null;
  const workspaceLogoUrl = institute.workspace_logo_url || institute.brand_logo_url || JUST_US_WORKSPACE_LOGO_URL;
  return {
    id: 'demo-only-just-us-community',
    name: 'justus',
    description: 'Community, Support, Friendship. A welcoming women-only space to move, read, chat and make genuine connections together.',
    image_url: workspaceLogoUrl,
    imageUrl: workspaceLogoUrl,
    description_image_url: JUST_US_RUN_GROUP_URL,
    gallery_images: [
      { id: 'demo-only-just-us-run-photo', image_url: JUST_US_RUN_GROUP_URL, position: 0 },
      { id: 'demo-only-just-us-book-photo', image_url: JUST_US_BOOK_CLUB_URL, position: 1 },
    ],
    private: true,
    sport_id: 'Fitness',
    sport_label: 'Fitness',
    institute_id: institute.id,
    institute_team_id: null,
    institute_team_names: ['Run & Chat', 'Pink Pace Walkers', 'Glow Getters', 'Just Us Book Club', 'Coffee & Conversations'],
    member_count: 36,
    demo_only: true,
  };
};

export const mergeAfriRunDemoCommunity = (content = {}, institute = {}, email = '') => {
  const demoCommunity = buildAfriRunDemoCommunity(institute, email) || buildJustUsDemoCommunity(institute, email);
  if (!demoCommunity) return content || {};
  const communities = (content?.communities || []).filter((row) => row?.id !== demoCommunity.id);
  return { ...(content || {}), communities: [demoCommunity, ...communities] };
};
